import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Revision = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M19.89 10.105a8.696 8.696 0 00-.789-1.456l-1.658 1.119a6.606 6.606 0 01.987 2.345 6.659 6.659 0 010 2.648 6.495 6.495 0 01-.384 1.231 6.404 6.404 0 01-.603 1.112 6.654 6.654 0 01-1.776 1.775 6.606 6.606 0 01-2.343.987 6.734 6.734 0 01-2.646 0 6.55 6.55 0 01-3.317-1.788 6.605 6.605 0 01-1.408-2.088 6.613 6.613 0 01-.382-1.23 6.627 6.627 0 01.382-3.877A6.551 6.551 0 017.36 8.797 6.628 6.628 0 019.446 7.39c.395-.167.81-.296 1.23-.382.107-.022.216-.032.324-.049V10l5-4-5-4v2.938a8.805 8.805 0 00-.725.111 8.512 8.512 0 00-3.063 1.29A8.566 8.566 0 004.11 16.77a8.535 8.535 0 001.835 2.724 8.614 8.614 0 002.721 1.833 8.55 8.55 0 005.061.499 8.576 8.576 0 006.162-5.056c.22-.52.389-1.061.5-1.608a8.643 8.643 0 000-3.45 8.684 8.684 0 00-.499-1.607z",
    key: "k0"
  }));
});
Revision.displayName = 'Revision';
export var RevisionDimensions = {
  height: 24,
  width: 24
};